const ADD_VALIDATION_CHECK_START = 'fulcrum/container/Validation/ADD_VALIDATION_CHECK_START'
const ADD_VALIDATION_CHECK_SUCCESS = 'fulcrum/container/Validation/ADD_VALIDATION_CHECK_SUCCESS'
const ADD_VALIDATION_CHECK = 'fulcrum/container/Validation/ADD_VALIDATION_CHECK'
const DISPATCH_ADD_VALIDATION_CHECK = 'fulcrum/container/Validation/DISPATCH_ADD_VALIDATION_CHECK'
const REMOVE_VALIDATION_CHECK_START = 'fulcrum/container/Validation/REMOVE_VALIDATION_CHECK_START'
const REMOVE_VALIDATION_CHECK_SUCCESS = 'fulcrum/container/Validation/REMOVE_VALIDATION_CHECK_SUCCESS'
const REMOVE_VALIDATION_CHECK = 'fulcrum/container/Validation/REMOVE_VALIDATION_CHECK'
const DISPATCH_REMOVE_VALIDATION_CHECK = 'fulcrum/container/Validation/DISPATCH_REMOVE_VALIDATION_CHECK'
const CLEAR_VALIDATION = 'fulcrum/container/Validation/CLEAR_VALIDATION'
// this is a global dispatch to run all validations in form
const DISPATCH_VALIDATE_FORM = 'fulcrum/containers/Validation/DISPATCH_VALIDATE_FORM'
const DISPATCH_VALIDATE_FORM_START = 'fulcrum/containers/Validation/DISPATCH_VALIDATE_FORM_START'
const DISPATCH_VALIDATE_FORM_SUCCESS = 'fulcrum/containers/Validation/DISPATCH_VALIDATE_FORM_SUCCESS'
const REGISTER_ELEMENT = 'fulcrum/containers/Validation/REGISTER_ELEMENT'
const UPDATE_VALIDATION_VALUE = 'fulcrum/containers/Validation/UPDATE_VALIDATION_VALUE'

export {
  REGISTER_ELEMENT,
  ADD_VALIDATION_CHECK_START,
  ADD_VALIDATION_CHECK_SUCCESS,
  ADD_VALIDATION_CHECK,
  DISPATCH_ADD_VALIDATION_CHECK,
  REMOVE_VALIDATION_CHECK_START,
  REMOVE_VALIDATION_CHECK_SUCCESS,
  REMOVE_VALIDATION_CHECK,
  DISPATCH_REMOVE_VALIDATION_CHECK,
  CLEAR_VALIDATION,
  DISPATCH_VALIDATE_FORM,
  DISPATCH_VALIDATE_FORM_START,
  DISPATCH_VALIDATE_FORM_SUCCESS,
  UPDATE_VALIDATION_VALUE,
}
